export const CUSTOM_DURATION_NAME = "custom";
export const DASHBOARD_ID_PREVIEW_MODE = "PREVIEW";

export const CTA_SAVE = "home.dashboards.wizard.save.btn";
export const CTA_SAVE_TOOLTIP = "home.dashboards.wizard.save.btn.tooltip";
export const CTA_SAVING = "home.dashboards.wizard.saving.btn";

export const SUPPORTED_CATEGORIES_WITH_SEGMENTS_METRICS = ["EngagementVisits"];

export const INDUSTRY_FAMILY_NAME = "Industry";
